export const themes = {
  movingUp: {
    token: {
      colorPrimary: '#f39200',
      fontWeightStrong: '200',
      fontFamily: 'Poppins,sans-serif'
    },
    cssVar: true,
  }
};